import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const AlboCategoria: AnaColumn[] = [
  {
    itemType: "",
    configuration:
    {

      titleGriglia: 'descrizioneSoggetto - $descrizioneSede',
      titleForm: ' descrizioneSoggetto - $descrizioneSede',
      breadcrumbCaption: 'Categorie Albo',
      idBreadcrumbGroup: 'AlboCategoria',
      campoTitle: ['descrizioneSede', 'descrizioneSoggetto'],
      masterKey: 'id',
      service: 'AlboCategoria',
      api: 'AlboCategoria',
      filterList: '/$idSede',
      filterEditor: '?id=$',
      formType: 'simple',
      startTemplate: 'grid',
      helpDoc: 'CategoriaAlbo2.html',
      idTabRif: [
        {
          key: 'idSede',
          value: 'idSede'
        },
      ],
      queryFilter: [
        {
          key: 'idAlboCategoria',
          value: 'id'
        },
        {
          key: 'idCategoriaAlboGestore',
          value: 'idCategoriaAlboGestore'
        },

      ],
      nCol: 1,
      toolbarSettings: {
        service: 'alboCategoria',


      }

    }

  },

  {
    itemType: "group", groupWidth: 700, colCount: "3", class: "", caption: "Estremi Iscrizione Albo Gestori Ambientali", data: [

      {
        type: 'campoSpecial',
        editorType: 'dxSelectBox',
        dataField: "idCategoriaAlboGestore",
        caption: "Categ.albo",
        dataType: "",
        orderGriglia: 1,
        nCol: 3,
        maxLength: '45',
        showInColumnChooser: true,
        allowHiding: false,
        colWidth: '60',
        class: "required", validation: [{ type: "required", message: "Campo Obbligatorio" }],
        lista: {
          dataSource: 'CategoriaAlboGestore',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false,
          related: ['tipoIscrizione'],
          cascading: ["id|idClasseAlboGestore"]

        }

      },
      {
        type: 'campoSpecial',
        editorType: 'dxSelectBox',
        dataField: "idClasseAlboGestore",
        caption: "Descrizione Classe",
        colCaption: 'Codice Classe',
        dataType: "",
        nCol: 7,
        maxLength: '45',
        showInColumnChooser: true,
        allowHiding: false,
        colVisible: false,
        colWidth: '60',
        lista: {
          dataSource: 'ClasseAlboGestore',
          valueExpr: 'idClasse',
          displayExpr: 'descrizione',
          width: '400',
          static: false,
          queryString: '?idCategoria=$idCategoriaAlboGestore',
          related: ['idClasse|idClasse']
        },

      },
      {
        type: 'campo',
        dataField: "idClasseAlboGestore_clone",
        colCaption: 'Classe',
        dataType: "",
        visible: false,
        colAlignment: 'center',
        orderGriglia: 2,
        colWidth: '60',
        clone: 'idClasseAlboGestore',

      },

      { type: 'campo', dataType: "", colWidth: '10', disableOnUpdate: true, colVisible: false, showClearButton: false, dataField: 'idClasse', orderGriglia: 3, labelVisible: false, caption: 'Classe', nCol: 1, },


      {
        showInColumnChooser: true,
        allowHiding: false,
        colVisible: false,
        type: 'campo',
        dataField: "tipoIscrizione",
        caption: "Tipo Iscrizione",
        dataType: "",
        nCol: 4,

        disableOnUpdate: true,
        editorClass: 'tipo-iscrizione',
        showClearButton: false

      },

      {
        showInColumnChooser: true, allowHiding: false,
        type: 'campoData',
        dataField: "dataInizio",
        caption: "Del",
        colCaption: 'Data',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        // nCol:3,
        // colWidth:'90px',
        width: 66,
        orderGriglia: 4,
      },

      {
        showInColumnChooser: true, allowHiding: false,
        type: 'campoData',
        dataField: "dataScadenza",
        caption: "Scadenza",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        width: 55,
        // nCol:4,
        orderGriglia: 5,
        // colWidth:'90px',
      },




    ]
  },
  {
    itemType: "group", colCount: "1", class: "col-12", caption: "Elenco EER autorizzati", groupDataField: 'elencoEer', data: [

      {
        type: 'campoGriglia', labelVisible: false, colSpan: "1", dataField: 'listaCer',
        caption: 'Lista EER',
        colVisible: false,
        nCol: 100,
        showInColumnChooser: false,

        formGrid: {
          service: 'listaCer',
          api: '',

          remoteOperation: false,
          queryString: '',
          isEditable: true,
          isEditableNewRow: true,
          isEditableEditRow: true,
          isEditableDeleteRow: true,
          showToolbarTop: true,
          tableHeight: 350,
          tableWidth: 1000,
          showFilter: false,
          selectionRowMode: 'none',  // 'single' | 'detail' | 'multiple';
          idTable: 'listaCer',
          isSearchable: false

        }


      },

    ]
  }
]